import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ImportWorkflowModalDataComponent } from './import-workflow-modal/import-workflow-modal.component';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-use-template-actions',
  templateUrl: './use-template-actions.component.html',
  styleUrls: ['./use-template-actions.component.scss'],
  standalone: false
})
export class UseTemplateActionsComponent implements OnInit {
  @Input() row!: any;
  @Input() isEntitledToViewWorkflow = false;
  @Input() isEntitledToImportWorkflow = false;

  @Output() action = new EventEmitter<string>();


  showTestModal: boolean = false; // Added by Vipul on 30-07-2026


  // Added by Vipul on 30-07-2026
  testWorkflowId!: string;
  testVersionId!: string;
  testClientId!: string;
  // End by Vipul on 30-07-2026
  clientSub: Subscription;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    public _context: WorkflowContextService
  ) {}

  onDropdownClick(event: MouseEvent) {
    event.stopPropagation();
    alert('Dropdown clicked');
  }
  onMenuOpened() {
    alert('Menu opened');
  }

   // ✅ Test → open in new tab
  onTestClick(workflowId: string, versionId: string) {
    // Added by Vipul on 30-07-2026
    this.testWorkflowId = workflowId;
    this.testVersionId = versionId;
    this.testClientId = this._context?.client?.id;

    this.showTestModal = true;
    // End by Vipul on 30-07-2026
  }

  // ✅ View Workflow → open in new tab
  onViewWorkflow() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/admin/workflow-builder', this.row.id])
    );
    window.open(url, '_blank');
  }

  // ✅ Import Workflow → open modal
  onImportWorkflow() {
    this.dialog.open(ImportWorkflowModalDataComponent, {
      width: '900px',        // ✅ increase size
      maxWidth: '80vw',       // ✅ override default 80vw
      height: '80vh',         // ✅ optional (scrollable modal)
      autoFocus: false,
       data: {
        sourceWorkflowId: this.row.id,
        targetJurisdictionId: this._context?.client?.id
      }
    });
  }

   ngOnInit() {
    // Added by Vipul on 30-07-2026
    this.testWorkflowId = this.row.id;
    this.testVersionId = this.row.workflowVersionId;
    this.testClientId = this._context?.client?.id;
    // End by Vipul on 30-07-2026
  }
}
